import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef
 as MatDialogRef  } from '@angular/material/legacy-dialog';
import { StationGroup } from 'src/tmc-yard/client/model/station-group';
import { StructureSelctionFilter, StructureSelection, StructureSelectionContext, StructureSelectionDialogScope } from 'src/tmc-yard/common/structure-selection/structure-selection.model';
import { MovementOrderDetails } from '../../movement-orders.model';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-movement-order-rerouting-dialog',
  templateUrl: './movement-order-rerouting-dialog.component.html',
  styleUrls: ['./movement-order-rerouting-dialog.component.scss']
})
export class MovementOrderReroutingDialogComponent {

  confirmDialogEnabled = true;
  movementOrderDetails: MovementOrderDetails;

  stationGroups: Array<StationGroup>;
  selectedStationGroup: StationGroup = null;
  structureSelectionValid = false;

  selection: StructureSelection;
  structureSelectionContext: StructureSelectionContext;

  constructor(
    private dialog: MatDialogRef<MovementOrderReroutingDialogComponent>,
    public translationService: TranslationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.movementOrderDetails = this.data.movementOrderDetails;

    this.selection = new StructureSelection();
    this.selection.stationSetId = (this.movementOrderDetails.targetStationSetId);
    this.structureSelectionContext = new StructureSelectionContext(StructureSelectionDialogScope.STATION, this.selection, StructureSelctionFilter.WAITING_AREA);
    this.structureSelectionContext.setFixedStationSet(this.movementOrderDetails.targetStationSetId);
    this.structureSelectionContext.validation$.subscribe(validation => {
      this.structureSelectionValid = validation;
      this.updateEnabledment();
    });
  }

  public confirmDialog() {
    this.dialog.close(this.structureSelectionContext.selection.stationId);
  }

  public cancelDialog() {
    this.dialog.close(null);
  }

  private updateEnabledment() {
    this.confirmDialogEnabled = this.structureSelectionValid && this.structureSelectionContext.selection.stationSetId === this.movementOrderDetails.targetStationSetId
  }

}
